/* eslint-disable @typescript-eslint/ban-ts-comment */
// eslint-disable
import './index.scss';

import { Popup } from 'vant';
import { Component, Vue } from 'vue-property-decorator';
import { popPageManager } from '@/shared/tools/popPageManager';
import { VueClass } from 'vue-class-component/lib/declarations';
import platform from '@/shared/utils/platform';
import { checkLinkIsNotAccessDomain } from '@/api/native/wechat';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';

@Component({ name: 'ContractPage' })
class ContractPage extends Vue {
  public isOpen = false;

  private html = '';

  private vue: Vue | null = null;

  public open() {
    this.isOpen = true;
  }

  public openHTML(url: string) {
    this.html = url;
    this.vue = null;
    this.isOpen = true;
  }

  public openVue(vue: Vue | null) {
    this.html = '';
    this.vue = vue;
    this.isOpen = true;

    Vue.nextTick(() => {
      if (vue) {
        const hook = document.getElementsByClassName('contractPopHook')[0];
        vue.$mount();
        hook.appendChild(vue.$el);
      }
    });
  }

  public close() {
    this.isOpen = false;
    this.html = '';

    if (this.vue && this.vue !== null) {
      if (this.vue.$el) {
        this.vue.$el.remove();
      }

      this.vue.$destroy();
      this.vue = null;
    }
  }

  private renderHtmlContent() {
    return (
      <div v-class="content">
        <iframe
          style={{
            width: '100%',
            height: '100%',
            overflow: 'auto',
            padding: '10px 15px',
            border: 'none',
          }}
          src={decodeURI(this.html)}
        />
        {/* <div domProps={{innerHTML: this.html}}/> */}
      </div>
    );
  }

  private render() {
    return (
      <Popup class="ContractPage" position="right" v-model={this.isOpen}>
        {this.html !== '' ? (
          this.renderHtmlContent()
        ) : (
          <div v-class="content" class="contractPopHook"></div>
        )}
        <div
          v-class="close"
          onClick={() => {
            this.close();
          }}
        >
          <p v-class="close-text">关闭</p>
        </div>
      </Popup>
    );
  }
}

let instance: ContractPage;

function getInstance(): ContractPage {
  if (!instance) {
    instance = new ContractPage().$mount();
    document.body.appendChild(instance.$el);
  }

  return instance;
}

export const contractPage = {
  async open(url: string, isPdfUrl = false): Promise<void> {
    /** 微信小程序环境下，如果链接不在白名单，则跳转到错误提示页 */
    if (platform.isWechatMini && (await checkLinkIsNotAccessDomain(url) || isPdfUrl)) {
      jumpToNewVersion(NewVersionEnum.MINI_PROGRAMS_PROMPT, false);
    } else {
      getInstance().openHTML(url);
      // @ts-ignore
      popPageManager.openPopPage(getInstance());
    }
  },

  openVue(CustomComp: VueClass<Vue>): void {
    const childVue = new CustomComp();
    getInstance().openVue(childVue);
    // @ts-ignore
    popPageManager.openPopPage(getInstance());
  },

  // 标记当前是显示还是关闭状态
  isOpen(): boolean {
    return getInstance().isOpen;
  },

  close(): void {
    if (this.isOpen()) {
      getInstance().close();
    }
  },
};
